import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},

    {key:'orgName', label: '部门'},
    {key:'loginName', label: '职工号'},
    {key:'employeeName', label: '姓名'},
    {key:'sex', label: '性别'},
    {key:'name', label: '问卷名称'},
    {key:'status', label: '问卷状态'},
    {key:'createTime', label: '创建时间'}
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('survey/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const querySearchById = (id) => {
    return fetch.get('survey/view/'+ id, {})
    .then(response => {
        return response.payload.data;
    })
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('survey/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    return new Promise(function(resolve, reject) {
        if(DataGrid.selections.length === 0) {
            Modal.error({
                title: '请先选择一项或多项！',
                content: '只有勾选一项或多项后才能删除！',
            });
        } else {
            Modal.confirm({
                title: '确定删除该记录？',
                content: '删除后将无法恢复！',
                onOk() {
                    remove(DataGrid.selections).then(response => {
                        if(response.code === 200) {
                            message.success(response.message);
                            resolve();
                            callback();
                        } else {
                            reject();
                        }
                    });
                },
                onCancel() {},
                okText:"确认",
                cancelText:"取消"
            });
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'survey'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0  || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    querySearch,
    remove,
    headers,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    getSelectionData,
    querySearchById
}